import { createFileRoute, redirect } from "@tanstack/react-router";

import { AppLayout } from "@onesolution/components";
import { getClientInfosFromServer } from "@onesolution/serverFn";
import { getCurrentUserDetails } from "@onesolution/serverFn/user";
import { getUserFromSession } from "@onesolution/utils";

export const Route = createFileRoute("/app/_layout")({
	beforeLoad: async () => {
		const user = await getUserFromSession();

		if (!user || !user.isAuthenticated) {
			throw redirect({ to: "/login" });
		}

		return user;
	},
	loader: async ({ context: { queryClient, ...user } }) => {
		const [clientInfos, userInfos] = await Promise.all([
			getClientInfosFromServer(),
			getCurrentUserDetails(),
		]);

		return { user: { ...userInfos, ...user }, client: clientInfos };
	},
	component: AppLayout,
});
